// extracted by mini-css-extract-plugin
export default {"Breadcrumb":"Breadcrumb_Breadcrumb__w8kVt"};